import React, {  ReactNode, useEffect, useMemo, useState } from "react"
import {  userGetLocalInfo } from "../../user/info"
import { CircularLoading } from "../utils/loading";

import { ChatsInfo, ConsultInfo, NewClientsInfo, WANumberResult, getTableNameByID } from "./types";

import { sendServerRequest } from "../../server/request";
import { URLS } from "../../env/urls";


import { LoadingButton } from "@mui/lab";
import { Button } from "@mui/material";
import { openGlobalSnack } from "../utils/snack";
import { PropostalStatus, propostalStatusPTBR, propostalStatusPTBRToNormal } from "../types/propostals";

import { DisplayCard } from "../whatsapp/datadisplay";

import { PropostalInfo } from "./types";


import { GraphTotalByGenericParam } from "./graphgeral";
import { GraphTotalByDate } from "./propostalbyhour";
import { calculatePropostalsSumByParam, getComissionByTableName } from "./propostals";
import { formatLocalCurrency } from "../../utils/currency";
import { SelectConsultData, UpdateConsultaData } from "../utils/consultdata";
import { clientContactSourceToPTBR, chatSourceToPTBR } from "../types/callsouce";
import { DisplayCardClientsInfo } from "./info/clientsInfo";
import { ChatsGraph } from "./info/graphchat";
import { SelectFromItems } from "../utils/forms/select";




function calculatePropostalInfo(propostal:Array<PropostalInfo>){
   let total=0;
   let greater=0;
   let min=0;
   for(let p of propostal){
       total+=p.client_withdrawn_value;
       if(p.client_withdrawn_value>greater)
          greater=p.client_withdrawn_value;
       if(p.client_withdrawn_value<min||min==0)
          min=p.client_withdrawn_value;
   }
   return {
      minPropostal:min,
      greaterPropostal:greater,
      total,
      avereage:propostal.length?total/propostal.length:0,
   }
}
function calculateComission(propostal:Array<PropostalInfo>){
   let {data}=calculatePropostalsSumByParam(propostal,'table_fee_id',getTableNameByID);
   let ret:{[key:string]:{
       total:number,
       totalComission:number,
       comissionPorcetage:number,
       param:string,
       numberOfPropostals:number,
   }}={};
   for(let p of Object.values(data)){
        const comission=getComissionByTableName(p.param);
        ret[p.param]={
            ...p,
            comissionPorcetage:comission,
            totalComission:comission*p.total,
        }
       
   }
   return ret;
}
interface PropostalFilters{
    source:string,
    status:string,
    table:string,
    ddd:string,
    whatsapp:string,
}
const EMPTY_PROPOSTAL_FILTERS:PropostalFilters={source:'',status:'',table:'',ddd:'',whatsapp:''};

// Monta as opções de cada filtro a partir das propostas carregadas. Fonte,
// status e tabela recebem rótulo em PT-BR; DDD e WhatsApp ficam como estão.
function buildPropostalFilterOptions(propostals?:Array<PropostalInfo>){
    const sources=new Set<string>();
    const statuses=new Set<string>();
    const tables=new Set<string>();
    const ddds=new Set<string>();
    const whatsapps=new Set<string>();
    for(const p of propostals||[]){
        if(p.call_source)sources.add(p.call_source);
        if(p.status)statuses.add(p.status);
        if(p.table_fee_id)tables.add(p.table_fee_id);
        if(p.clientDDD)ddds.add(String(p.clientDDD));
        if(p.sender_number)whatsapps.add(p.sender_number);
    }
    const labeled=(set:Set<string>,fn:(v:string)=>string)=>
        Array.from(set).map(v=>({value:v,label:fn(v)})).sort((a,b)=>a.label.localeCompare(b.label));
    return {
        sources:labeled(sources,clientContactSourceToPTBR),
        statuses:labeled(statuses,(s)=>propostalStatusPTBR(s as PropostalStatus)),
        tables:labeled(tables,getTableNameByID),
        ddds:Array.from(ddds).sort(),
        whatsapps:Array.from(whatsapps).sort(),
    };
}

// Aplica todos os filtros ativos com AND; filtro vazio é ignorado.
function applyPropostalFilters(propostals:Array<PropostalInfo>|undefined,f:PropostalFilters){
    if(!propostals)return undefined;
    return propostals.filter(p=>
        (!f.source||p.call_source==f.source)&&
        (!f.status||p.status==f.status)&&
        (!f.table||p.table_fee_id==f.table)&&
        (!f.ddd||String(p.clientDDD)==f.ddd)&&
        (!f.whatsapp||p.sender_number==f.whatsapp)
    );
}

function PropostalsFilterBar({options,filters,onChange,onClear,filteredCount,totalCount}:{
    options:ReturnType<typeof buildPropostalFilterOptions>,
    filters:PropostalFilters,
    onChange:(key:keyof PropostalFilters,value:string)=>void,
    onClear:()=>void,
    filteredCount:number,
    totalCount:number,
}){
    const hasActiveFilter=Object.values(filters).some(v=>!!v);
    const cellStyle:React.CSSProperties={minWidth:'160px',flex:'1 1 160px',maxWidth:'220px'};
    return (
        <div style={{maxWidth:'1000px',margin:'auto',marginBottom:'25px',padding:'14px',border:'1px solid #e0e0e0',borderRadius:'10px'}}>
            <div style={{display:'flex',flexWrap:'wrap',gap:'12px',justifyContent:'center',alignItems:'center'}}>
                <div style={cellStyle}><SelectFromItems label="Fonte" defaultValue={filters.source} items={options.sources} onChangeItem={(v)=>onChange('source',v)}/></div>
                <div style={cellStyle}><SelectFromItems label="Status" defaultValue={filters.status} items={options.statuses} onChangeItem={(v)=>onChange('status',v)}/></div>
                <div style={cellStyle}><SelectFromItems label="Tabela" defaultValue={filters.table} items={options.tables} onChangeItem={(v)=>onChange('table',v)}/></div>
                <div style={cellStyle}><SelectFromItems label="DDD" defaultValue={filters.ddd} items={options.ddds} onChangeItem={(v)=>onChange('ddd',v)}/></div>
                <div style={cellStyle}><SelectFromItems label="WhatsApp" defaultValue={filters.whatsapp} items={options.whatsapps} onChangeItem={(v)=>onChange('whatsapp',v)}/></div>
            </div>
            <div style={{display:'flex',justifyContent:'center',alignItems:'center',gap:'16px',marginTop:'14px',flexWrap:'wrap'}}>
                <span style={{fontSize:'0.85rem',color:'#666'}}>{`Exibindo ${filteredCount} de ${totalCount} propostas`}</span>
                <Button size="small" variant="outlined" disabled={!hasActiveFilter} onClick={onClear}>Limpar filtros</Button>
            </div>
        </div>
    );
}

function PropostalsDash({serverPropostals,consults,newClients,serverChats}:{serverChats?:Array<ChatsInfo>,consults?:Array<ConsultInfo>,serverPropostals?:Array<PropostalInfo>,newClients?:NewClientsInfo}){
    const [waNumberResult,setWANumberResult]=useState<undefined|{[key:string]:WANumberResult}>();
    const [productionTotal,setProductionTotal]=useState(0);
    const [numberOfPropostalsTotal,setTotalNumberOfPropostalsTotal]=useState(0);
    const [filters,setFilters]=useState<PropostalFilters>(EMPTY_PROPOSTAL_FILTERS);

    // Opções dos selects, derivadas do conjunto completo de propostas carregadas.
    const filterOptions=useMemo(()=>buildPropostalFilterOptions(serverPropostals),[serverPropostals]);
    // Propostas exibidas após aplicar os filtros (alimenta cards e gráficos).
    const propostals=useMemo(()=>applyPropostalFilters(serverPropostals,filters),[serverPropostals,filters]);
    // Chats só respondem ao filtro de fonte (não possuem status/tabela/DDD de proposta).
    const chats=useMemo(()=>{
        if(!serverChats)return undefined;
        if(!filters.source)return serverChats;
        return serverChats.filter(ch=>ch.call_source==filters.source);
    },[serverChats,filters.source]);

    // Zera os filtros sempre que um novo conjunto de propostas é carregado.
    useEffect(()=>{setFilters(EMPTY_PROPOSTAL_FILTERS);},[serverPropostals]);

    useEffect(()=>{
       if(!propostals)
          return;
       let waNumbers:{[key:string]:WANumberResult}={}
       for(let p of propostals){
            if(!waNumbers[p.sender_number]){
                waNumbers[p.sender_number]={
                    sender_number:p.sender_number,
                    numberOfPropostals:0,
                    totalValue:0,
                }
            }
            waNumbers[p.sender_number].numberOfPropostals++;
            waNumbers[p.sender_number].totalValue+=p.client_withdrawn_value;
       }
       let tprod=0;
       let tnprop=0;
       for(let d of Object.values(waNumbers)){
          tprod+=d.totalValue;
          tnprop+=d.numberOfPropostals;
       }
       setProductionTotal(tprod);
       setTotalNumberOfPropostalsTotal(tnprop);
       setWANumberResult(waNumbers);
   },[propostals]);
   if(!propostals)
      return null;
   const onChangeFilter=(key:keyof PropostalFilters,value:string)=>setFilters(prev=>({...prev,[key]:value}));
   return (
       <div style={{textAlign:'center'}}>
          <PropostalsFilterBar
              options={filterOptions}
              filters={filters}
              onChange={onChangeFilter}
              onClear={()=>setFilters(EMPTY_PROPOSTAL_FILTERS)}
              filteredCount={propostals.length}
              totalCount={serverPropostals?.length||0}
          />
          {propostals.length<1?<p>Sem Propostas</p>:
             <div style={{display:'block'}}>
                 <TotalPorpostalInfo newClients={newClients} consults={consults} propostals={propostals} totalProd={productionTotal} totalNumberPropostals={numberOfPropostalsTotal}/>
                 <GraphTotalByGenericParam label='Tabela' showPieLegend={true} showParamName={getTableNameByID} propostals={propostals} param='table_fee_id'/>
                 <GraphTotalByGenericParam label='Fonte' showPieLegend={false} showParamName={clientContactSourceToPTBR}  propostals={propostals} param='call_source'/>
                 <GraphTotalByGenericParam label='Canal' showPieLegend={true} showParamName={chatSourceToPTBR} propostals={propostals} param='chat_source'/>
                 <GraphTotalByGenericParam label='Número/Conta' propostals={propostals} param='sender_number'/>
                 <GraphTotalByGenericParam label='DDD' propostals={propostals} param='clientDDD'/>
                 <GraphTotalByGenericParam label='Status' 
                     //@ts-ignore
                     showParamName={propostalStatusPTBR} 
                     propostals={propostals} 
                     param='status'/>
                <GraphTotalByDate label='Dia Do Mês UTC' propostals={propostals} param='utcDay'/>
                <GraphTotalByDate label={`Hora GMT ${(new Date().getTimezoneOffset())/-60}`} propostals={propostals} param='hour'/>
                <GraphTotalByDate label='Hora UTC' propostals={propostals} param='utcHour'/>
                <ChatsGraph chats={chats} type="state"/>
                <ChatsGraph chats={chats} type='source'/>
             </div>
          }
       </div>
   ) 
}
function TotalPorpostalInfo({consults,propostals,totalProd,totalNumberPropostals,newClients}:{consults?:Array<ConsultInfo>,propostals:Array<PropostalInfo>,totalProd:number,totalNumberPropostals:number,newClients?:NewClientsInfo}){
    const [comissionTotal,setComissionTotal]=useState(0);
    const [comissionInfo,setComissionInfo]=useState<null|ReactNode>(null)
    const [propostalsInfo,setPropostalInfoNode]=useState<null|ReactNode>(null);
    const [consultsProviders,setConsultsProviders]=useState<null|ReactNode>(null);
    const [conversion,setConversion]=useState<null|ReactNode>(null);
    useEffect(()=>{
         if(propostals){
              const r=calculateComission(propostals);
              const propostalInfo=calculatePropostalInfo(propostals);
              const rObj=Object.values(r);
              let total=0;

              for(let val of rObj){
                  total+=val.totalComission;
                  
              }
              let plInfoNode=<div>
                  <p>{`Maior proposta: ${formatLocalCurrency(propostalInfo.greaterPropostal)}`}</p>
                  <p>{`Menor proposta: ${formatLocalCurrency(propostalInfo.minPropostal)}`}</p>
                  <p>{`Média da proposta: ${formatLocalCurrency(propostalInfo.avereage)}`}</p>
              </div>
              let cInfo=<div>
                {total>0?rObj.map(info=>
                    <p>{`${info.param}: ${formatLocalCurrency(info.total)} * ${(info.comissionPorcetage*100).toFixed(1)}% = ${formatLocalCurrency(info.totalComission)} (${((100*(info.totalComission/total)).toFixed(1))}%)`}</p>
                ):null}
                {total>0?<p>{`Comissão média: ${(100*(total/totalProd)).toFixed(1)}%`}</p>:null}
                
              </div>
              setConversion(<div>
                <p>{`Taxa de conversão: ${!consults||consults.length==0?'Inderminado':`${((100*(propostals.length/consults.length))).toFixed(2)}%`}`}</p>
              </div>)
              setComissionTotal(total);
              setComissionInfo(cInfo);
              setPropostalInfoNode(plInfoNode);
         }
    },[propostals,totalProd]);
    useEffect(()=>{
       if(!consults||consults.length<1)
          return;
       let ret:any={};
       for(let c of consults){
         if(!ret[c.provider]){
              ret[c.provider]={
                total:0,
              }
         }
         ret[c.provider].total++;
       }
       const keys=Object.keys(ret);
       let cpro=<div>
          {keys.map(k=>{
            return <p>{`${k}: ${ret[k].total} (${((ret[k].total/consults.length)*100).toFixed(2)}%)`}</p>
          })}
       </div>
       setConsultsProviders(cpro);
    },[consults])
    return (
      <div style={{textAlign:'center',marginBottom:'50px'}}>
        <DisplayCard primary="Produção Total" toolTip={propostalsInfo} secondary={`R$ ${totalProd.toLocaleString('pt-BR')}`}/>
        <DisplayCard marginLeft='9px' toolTip={comissionTotal>0?comissionInfo:null} primary="Comissão Total" secondary={`${formatLocalCurrency(comissionTotal)}`}/>
        <DisplayCard marginLeft='9px' toolTip={conversion} primary="Número de Propostas" secondary={`${totalNumberPropostals}`}/>
        <DisplayCard marginLeft='9px' primary="Número de Consultas" toolTip={consultsProviders} secondary={`${consults?consults.length:0}`}/>
        <DisplayCardClientsInfo newClients={newClients}/>
      </div>
   )
}
export function FgtsDashboard(){
    const [loadingUser,setLoadingUser]=useState(true);
    const [canSeePropostals,setCanSeePropostals]=useState(false);
    const [selectedData,setSelectedData]=useState<undefined|UpdateConsultaData>(undefined);
    const [loadingPropostals,setLoadingPropostals]=useState(false);
    const [propostals,setPropostals]=useState<Array<PropostalInfo>|undefined>(undefined);
    const [chats,setChats]=useState<Array<ChatsInfo>|undefined>(undefined);
    const [newClients,setNewClients]=useState<NewClientsInfo|undefined>(undefined)
    const [consults,setConsultsInfo]=useState<Array<ConsultInfo>|undefined>(undefined);
    useEffect(()=>{
       userGetLocalInfo().then(e=>{
           if(e){
               setCanSeePropostals(e.permission.can_see_propostals);
               setLoadingUser(false);
           }else{
              
           }
       });
    },[])
    useEffect(()=>{
       if(!loadingPropostals||!selectedData)
           return;
       getPropostals().then(e=>{
         setLoadingPropostals(false);
       }).catch(e=>{
          openGlobalSnack('Erro ao carregar propostals','error');
          setLoadingPropostals(false);
       })
    },[loadingPropostals]);
    useEffect(()=>{
       
    },[propostals]);
    return (
        <div>
            {loadingUser?<CircularLoading/>:
            <div>
                {canSeePropostals?
                <div>
                    <SelectConsultData disabled={loadingPropostals} onUpdate={(d)=>{setSelectedData(d)}}/>
                    <div style={{textAlign:'center'}}>
                    <LoadingButton disabled={isDisabled()}  loading={loadingPropostals} onClick={()=>setLoadingPropostals(true)} variant="contained">Consultar Propostas</LoadingButton>
                    <div style={{marginTop:'40px'}}>
                    <PropostalsDash serverChats={chats} consults={consults} serverPropostals={propostals} newClients={newClients}/>
                    </div>
                    </div>
                </div>
                :<div>
                    <p>Acesso negado.</p>
                </div>}
            </div>
            }
            
        </div>
    )   
    async function getPropostals(){
        
        if(!selectedData)
              return;
        const fromDate=selectedData.start;
        const toDate=selectedData.end;
        let propostalStatus:Array<PropostalStatus>=[];
        if(selectedData.propostalStatus&&selectedData.propostalStatus){
             propostalStatus=propostalStatusPTBRToNormal(selectedData.propostalStatus);
        }
        const sendData={
             fromDate,
             toDate,
             v8Ids:selectedData.v8,
             senderNumbers:selectedData.wa,
             status:propostalStatus,
        };
        try{
            const r=await sendServerRequest('POST',URLS.propostals.get,sendData);
            setChats(r.data.data.chats);
            setPropostals(r.data.data.propostals);
            setConsultsInfo(r.data.data.consults);
            setNewClients(r.data.data.newClients);
        }catch(e){
            throw e;
        }
        
    }
    function isDisabled(){
         
         if(!selectedData)
            return true;
         if((!selectedData.v8||selectedData.v8.length<1)&&(!selectedData.wa||selectedData.wa.length<1))  
                return true;
         return false;
    }
}



